import * as Web3 from 'web3';
import * as AsekuroTypes from './types';

import {
    ContractsAPI,
    OrdersAPI,
    SignerAPI
} from './apis';

class Asekuro {    
    private web3: Web3;

    public static Types = AsekuroTypes;
    public contracts: ContractsAPI;
    public orders: OrdersAPI;
    public sign: SignerAPI;

    constructor(nodeHost?: string, asekuroConfig: AsekuroTypes.AsekuroConfig = {}) {
        if (nodeHost) {
            const web3Provider = new Web3.providers.HttpProvider(nodeHost);
            this.web3 = new Web3(web3Provider);
        } else if (typeof (window as any).web3 !== 'undefined') {
            this.web3 = new Web3((window as any).web3.currentProvider);
        } else {
            throw new Error('No node provided and web3 not found');
        }

        this.contracts = new ContractsAPI(this.web3, asekuroConfig);

        this.sign = new SignerAPI(this.web3);
        this.orders = new OrdersAPI(this.web3, this.contracts, this.sign);

    }
}

export default Asekuro;
